const validate = (values = {}) => {
  let errors = {};

  if (!values.name?.trim()) {
    errors.name = 'First name is required';
  } else if (!/^[a-zA-Z ]{3,50}$/.test(values.name)) {
    errors.name = 'Name must be 3-50 characters and contain only letters';
  }

  if (!values.last_name?.trim()) {
    errors.last_name = 'Last name is required';
  } else if (!/^[a-zA-Z ]{3,50}$/.test(values.last_name)) {
    errors.last_name = 'Name must be 3-50 characters and contain only letters';
  }

  if (!values.email) {
    errors.email = 'Email address is required';
  } else if (
    !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.email)
  ) {
    errors.email = 'Email address is invalid';
  }

  if (!values.phone) {
    errors.phone = 'Phone number is required';
  } else if (!/^\d{10}$/.test(values.phone)) {
    errors.phone = 'Phone number must be exactly 10 digits';
  }

    if (!values.age) {
    errors.age = "Age is required";
  } else if (!/^\d+$/.test(values.age) || values.age < 1 || values.age > 120) {
    errors.age = "Age must be a number between 1 and 120";
  }

  if (!values.weight) {
    errors.weight = "Weight is required";
  } else if (!/^\d+$/.test(values.weight) || values.weight < 1 || values.weight > 300) {
    errors.weight = "Weight must be a number between 1 and 300 kg";
  }

  if (!values.gender) {
    errors.gender = "Gender is required";
  } else if (!["Male", "Female", "Other"].includes(values.gender)) {
    errors.gender = "Please select a valid gender";
  }

  if (!values.address?.trim()) {
    errors.address = "Address is required";
  } else if (values.address.length < 10) {
    errors.address = "Address must be at least 10 characters long";
  }


  return errors;
};

export default validate;
